/**
 * Cart count + state sync cho nút header カートを確認 (top-search-bar).
 *
 * Sau add-to-cart (vd carousel マイプリンター) dispatch `ink:cart:updated`, file này
 * fetch /cart.js → cập nhật số lượng + đổi state nút (orange khi có item / white khi
 * rỗng) NGAY, không cần reload. Cũng refresh lúc load phòng SSR cache stale.
 *
 * Fail-silent: lỗi network chỉ bỏ qua, KHÔNG crash.
 */
(function () {
  'use strict';

  function updateButton(count) {
    const hasItems = count > 0;

    // Badge số lượng: cập nhật MỌI nút cart (drawer SP + nút cart SP + search-bar) —
    // không chỉ nút đầu DOM (trước dùng querySelector → các badge khác bị stale).
    document.querySelectorAll('[data-ink-cart-count]').forEach((badge) => {
      badge.textContent = count;
      badge.classList.toggle('hidden', !hasItems);
    });

    // State màu nút PC search-bar ([data-ink-cart-state]):
    // rỗng = bg-white text-ink-black, có hàng = bg-ink-orange text-white.
    const stateLink = document.querySelector('[data-ink-cart-state]');
    if (stateLink) {
      stateLink.classList.toggle('bg-ink-orange', hasItems);
      stateLink.classList.toggle('text-white', hasItems);
      stateLink.classList.toggle('bg-white', !hasItems);
      stateLink.classList.toggle('text-ink-black', !hasItems);
    }

    // State màu nút cart SP ([data-ink-cart-state-sp]):
    // rỗng = teal #159f9a (giống 2 nút còn lại), có hàng = cam.
    document.querySelectorAll('[data-ink-cart-state-sp]').forEach((btn) => {
      btn.classList.toggle('bg-ink-orange', hasItems);
      btn.classList.toggle('bg-[#159f9a]', !hasItems);
    });
  }

  async function refresh() {
    try {
      const res = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
      if (!res.ok) return;
      const cart = await res.json();
      updateButton(Number(cart.item_count) || 0);
    } catch (err) {
      console.warn('[cart-count] refresh failed', err);
    }
  }

  // Add-to-cart ở theme dispatch event này (section-top-loggedin.js, ...).
  document.addEventListener('ink:cart:updated', refresh);
  // Trang giỏ tự thêm/bớt quà tại chỗ (không reload) → chỉ đồng bộ số lượng.
  document.addEventListener('ink:cart:count-changed', refresh);
  // Phòng SSR cache stale (full-page cache) → đồng bộ lại lúc load.
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', refresh);
  } else {
    refresh();
  }
})();
